import type { FC, ReactNode } from 'react';
import type { Option } from './Select';
import Select, { type SelectProps } from './Select';
import Autocomplete from './Autocomplete';

// import { CircularProgress, Box } from '@mui/material';

interface CommonSelectConfigAttrs {
  multiples: boolean;
  placeholder: string;
  clearable?: boolean;
  open?: boolean;
  helperText?: ReactNode;
  onClose?: () => void;
  loading?: boolean;
  loadMoreRef?: (node?: Element | null) => void;
  onInputChange?: (value: string) => void;
  asAutocomplete?: boolean;
}

export interface CommonSelect {
  options: Option[];
}

export type CommonSelectProps = Pick<
  SelectProps,
  | 'handleChange'
  | 'name'
  | 'inputLabel'
  | 'required'
  | 'disabled'
  | 'dataTestId'
  | 'size'
  | 'sx'
  | 'hideErrorMessage'
> &
  CommonSelect &
  Partial<CommonSelectConfigAttrs>;

const CommonSelect: FC<CommonSelectProps> =
  ({
     handleChange,
     name,
     inputLabel,
     multiples,
     placeholder,
     options,
     clearable,
     helperText,
     onClose,
     open,
     loading,
     loadMoreRef,
     asAutocomplete,
     required,
     disabled,
     dataTestId,
     size,
     sx,
     hideErrorMessage,
   }) => {
    if (multiples) {
      return (
        <Autocomplete
          id={name}
          name={name}
          InputProps={{
            label: `${inputLabel}${required ? '*' : ''}`,
            helperText,
            disabled,
          }}
          options={options}
          onClose={onClose}
          open={open}
          loading={loading}
          loadMoreRef={loadMoreRef}
          dataTestId={dataTestId}
        />
      );
    }

    return (
      <Select
        name={name}
        inputLabel={inputLabel}
        options={options}
        handleChange={handleChange}
        placeholder={placeholder}
        clearable={clearable}
        helperText={helperText}
        loading={loading}
        loadMoreRef={loadMoreRef}
        asAutocomplete={asAutocomplete}
        required={required}
        disabled={disabled}
        dataTestId={dataTestId}
        size={size}
        sx={sx}
        hideErrorMessage={hideErrorMessage}
      />
    );
  };

export default CommonSelect;
